<template>
	<div class="qwxzs-main">
		<div class="left-menu">
			<div v-for="(item, index) in menuList" :key="index" @click="toPath(index)" class="left-menu-item" :style="{backgroundImage: leftIndex === index ? 'url(../../../static/young_left_select.png)' : ''}">
				<img :src="item.image" >
			</div>
		</div>
		<div class="top-choose-box">
			<img class="zswd" src="../../../static/xxhj_left_select.png" v-if="topIndex == 0">
			<!-- <img class="zswd" src="../../../static/xxhj_left_unselect.png" v-else @click="topIndex=0"> -->
			<!-- <img class="line" src="../../../static/young_line.png" > -->
			<!-- <img class="zsgl" src="../../../static/zsgl_select.png" v-if="topIndex == 1"> -->
			<!-- <img class="zsgl" src="../../../static/xxhj_right_unselect.png" v-if="topIndex == 0"> -->
		</div>
		<img class="back_home" @click="backHome" src="../../../static/back_young_home.png" >
		<div class="left-select" v-if="topIndex === 0">
			<div v-if="hdyyIndex == -1" class="kpsp-list">
				<div class="kpsp-main">
					<div class="kpsp-item" v-for="(item, index) in hdyyList" :key="index">
						<div class="kpsp-item-top">
							<img :src="$imgUrl + item.listImgPc" >
						</div>
						<div class="kpsp-item-bottom">
							<div class="kpsp-item-bottom-title">
								{{item.title}}
							</div>
							<div class="kpsp-item-bottom-time">
								时间:{{$moment(item.releaseTime).format('YYYY.MM.DD')}}
							</div>
							<div class="kpsp-item-bottom-address">
								地点:
							</div>
							<img src="../../../static/ljyy.png" @click="toDetails(index)">
						</div>
					</div>
				</div>
				<page v-if="topIndex === 0" :pageObj="params1" @getDataList="getData" ref="page"></page>
			</div>
			<div v-else>
				<div class="showHdyyBox" >
					<div class="back" @click="hdyyIndex=-1">

					</div>
					<img :src="$imgUrl + hdyyList[hdyyIndex].listImgPc" class="hdyyImg">
					<Scroll class="hdyy-details" :height="250">
						<div v-html="hdyyList[hdyyIndex].txt" style="color: #FFFFFF; text-align: left; margin-right: 15px;">

						</div>
					</Scroll>
					<div class="ljyy-button">
						立即预约
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import Page from '@/components/Page.vue'
	export default {
		name: 'qwxzs',
		data () {
			return {
				menuList: [
					{
						path: 'qwzs',
						image: '../../../static/qwxzs.png'
					},
					{
						path: 'xxhj',
						image: '../../../static/xxhj.png'
					},
					{
						path: 'kpxjt',
						image: '../../../static/kpxjt.png'
					},
					{
						path: 'zyzs',
						image: '../../../static/zyzs.png'
					},
					{
						path: 'hdyx',
						image: '../../../static/hdyx.png'
					},
				],
				leftIndex: 1,
				topIndex: 0,
				hdyyIndex: -1,
				hdyyList: [],
				params1: {
					current: 1,
					size: 3,
					channelId: 101,
					releaseTerrace: "releasePc"
				}
			}
		},
		components: {
			Page
		},
		mounted() {
			document.body.scrollTop = document.documentElement.scrollTop = 0
			this.$store.state.showTop = true
		},
		methods: {
			backHome() {
				this.$router.push('young_index')
			},
			toPath(Index) {
				let that = this
				if(Index != that.leftIndex) {
					that.$router.push(that.menuList[Index].path)
				}
			},
			getData(data) {
				if(this.topIndex === 0) {
					this.hdyyList = data
				} else {
					// this.kpjzList = data
				}
			},
			toDetails(hdIndex) {
				this.hdyyIndex = hdIndex
			}
		}
	}
</script>

<style lang="less" scoped>
	.qwxzs-main {
		margin-top: -33px;
		position: relative;
		width: 100%;
		min-width: 1500px;
		height: 900px;
		background-image: url(../../../static/xxhj_bg.png);
		background-size: 100% 100%;
		z-index: 1000;
		.top-choose-box {
			position: absolute;
			width: 350px;
			height: 106px;
			display: flex;
			justify-content: space-between;
			top: 50px;
			left: calc(50% - 175px);
			z-index: 998;
			.zswd {
				width: 140px;
				height: 106px;
				cursor: pointer;
			}
			.line {
				width: 52px;
				height: 2px;
				margin-top: 50px;
			}
			.zsgl {
				width: 140px;
				height: 106px;
				cursor: pointer;
			}
		}
		.bg_4 {
			position: absolute;
			width: 1150px;
			height: 350px;
			top: 227px;
			left: 250px;
			display: flex;
			justify-content: space-between;
			z-index: 997;
			.bg_4_left {
				background-image: url(../../../static/left_image.png);
				background-size: 100% 100%;
				height: 233px;
				width: 241px;
				margin-top: 50px;
				color: #2D5AC3;
				font-size: 23px;
				line-height: 180px;
				cursor: pointer;
			}
			.bg_4_middle {
				background-image: url(../../../static/qwxzs_image_4.png);
				background-size: 100% 100%;
				width: 675px;
				height: 386px;
				.bg_4_middle_image {
					width: 167px;
					height: 167px;
					border-radius: 50%;
					position: absolute;
					top: 70px;
					left: 300px;
					img {
						width: 100%;
						height: 100%;
						border-radius: 50%;
					}
				}
				.bg_4_middle_content {
					position: absolute;
					font-size: 13px;
					color: #FFFFFF;
					top: 60px;
					left: 490px;
					width: 330px;
					text-align: left;
				}
				.ckzsd {
					position: absolute;
					top: 180px;
					right: 330px;
					// cursor: pointer;
				}
			}
			.bg_4_right {
				background-image: url(../../../static/right_image.png);
				background-size: 100% 100%;
				height: 233px;
				width: 241px;
				margin-top: 50px;
				color: #2D5AC3;
				font-size: 23px;
				line-height: 180px;
				cursor: pointer;
			}
		}

		.back_home {
			position: absolute;
			width: 102px;
			height: 102px;
			left: 66px;
			bottom: 125px;
			cursor: pointer;
		}
		.left-menu {
			position: absolute;
			width: 170px;
			height: 430px;
			display: flex;
			justify-content: space-between;
			flex-direction: column;
			top: 75px;
			left: 55px;
			z-index: 1000;
			.left-menu-item {
				width: 168px;
				height: 65px;
				cursor: pointer;
				text-align: left;
				background-size: 100% 100%;
				img {
					height: 48px;
					margin-top: 9px;
				}
			}
		}
		.left-select {
			position: absolute;
			top: 150px;
			left: calc(50% - 400px);
			width: 1000px;
			height: 500px;
			.kpsp-main {
				margin-top: 60px;
				height: 360px;
				width: 100%;
				display: flex;
				.kpsp-item {
					width: 30%;
					margin: 0 1.66%;
					.kpsp-item-top {
						width: 275px;
						height: 181px;
						position: relative;
						margin: 0 auto;
						img {
							width: 100%;
							height: 100%;
						}
					}
					.kpsp-item-bottom {
						width: 90%;
						height: 120px;
						margin: 20px auto;
						background: rgba(255, 255, 255, 0.65);
						border-radius: 33px;
						white-space: nowrap;
						overflow: hidden;
						text-overflow: ellipsis;
						padding: 10px;
						.kpsp-item-bottom-title {
							color: #922627;
							font-size: 14px;
						}
						.kpsp-item-bottom-time {
							color: #2D5AC3;
							font-size: 11px;
							margin-top: 5px;
						}
						.kpsp-item-bottom-address {
							color: #2D5AC3;
							font-size: 11px;
							margin-top: 5px;
						}
						img {
							width: 105px;
							height: 40px;
							margin: 5px auto 0;
							cursor: pointer;
						}
					}
				}
			}
		}
		.showHdyyBox {
			width: 100%;
			height: 600px;
			background-size: 100% 100%;
			background-image: url(../../../static/hdyy_bg.png);
			position: relative;
			.back {
				position: absolute;
				right: 50px;
				top: 65px;
				width: 160px;
				height: 80px;
				cursor: pointer;
			}
			.hdyyImg {
				position: absolute;
				left: 65px;
				top: 210px;
				width: 360px;
				height: 200px;
				border-radius: 23px;
			}
			.hdyy-details {
				position: absolute;
				left: 500px;
				top: 160px;
				width: 400px;
				height: 400px;
				::-webkit-scrollbar {
					width: 6px;
					background-color: #3582fb;
					border-radius: 10px;
				}
				
				/* 滚动槽 */
				::-webkit-scrollbar-track {
					border-radius: 10px;
				}
				
				::-webkit-scrollbar-thumb {
					background-color: #2a68c9;
					border-radius: 10px;
				}
			}
			.ljyy-button {
				width: 100px;
				height: 30px;
				line-height: 30px;
				text-align: center;
				background-color: #F4DD8F;
				color: #264EA7;
				font-size: 13px;
				border-radius: 5px;
				position: absolute;
				right: 130px;
				bottom: 150px;
				cursor: pointer;
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/views/young/xxhj.vue